
function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

var rubberduck_ajax_queue = [];

export function callMeAjax(
  action,
  jata,
  callback,
  { preloader = true, showNotification = true } = {}
) {
  if (typeof jata === 'object' && jata !== null && typeof document.documentElement.getAttribute('lang') == 'string') {
    jata.append('rubberduck_language', document.documentElement.getAttribute('lang'));
  }
  return require("jquery").ajax({
    url: action,
    type: 'POST',
    data: jata,
    dataType: 'json',
    contentType: false,
    cache: false,
    processData: false,
    beforeSend: function () {
      if (preloader) {
        rubberduck_ajax_queue.unshift({ 'action': action });
        ajaxPreloader();
      }
    },
    success: function (data) {
      try {
        handleAjaxResponse(data, jata, showNotification);
        if (callback !== null && typeof callback !== 'undefined') {
          window[callback](data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    complete: function () {
      if (preloader) {
        rubberduck_ajax_queue.shift();
        if (rubberduck_ajax_queue.length === 0) {
          closeAjaxPreloader();
        }
      }
    }
  });
}

export function ajaxPreloader() {
  if ($('#loader').length === 0) {
    $('body #main').prepend('<div id="loader"><div class="spinner"><div class="spinner_loader"></div></div></div>');
  }

  $("#loader")
    .css("visibility", "hidden")
    .delay(10)
    .queue(function (next) {
      // Add a class with a delay for CSS transitions
      $(this).addClass("is-fading-in").css("visibility", "visible");
      next();
    }) // Fade in the loader
    .fadeIn(250, function () {
      // Remove the transition class after fadeIn()
      $(this).removeClass("is-fading-in").addClass("is-loading");
    });
}

export function closeAjaxPreloader() {
  $("#loader")
    .removeClass("is-loading")
    .addClass("is-fading-out")
    .fadeOut("250", function () {
      $(this).remove();
    });
}

export async function handleAjaxResponse(data, formData, showNotification = true) {
  var redirect_to = "";

  if (data == null) return;

  if (typeof data.redirect_url !== "undefined" && data.redirect_url !== null) {
    redirect_to = data.redirect_url;
  }

  var redirect_timeout = 0;
  if (typeof data.redirect_timeout !== "undefined" && data.redirect_timeout !== null && !isNaN(data.redirect_timeout)) {
    redirect_timeout = data.redirect_timeout;
  }

  var target_blank = false;

  if (typeof data.target_blank !== "undefined" && data.target_blank === true) {
    target_blank = true;
  }

  if (data.status && data.message && showNotification) {
    displayNotification(data.status, data.message, data?.notification ?? {});
  }

  if (redirect_to != "") {
    setTimeout(() => {
      if (target_blank) {
        window.open(redirect_to, "_blank");
      } else {
        window.location.href = redirect_to;
      }
    }, redirect_timeout);
  }
  if (
    typeof data.callback !== 'undefined' &&
    data.callback !== null &&
    data.callback.type !== null
  ) {
    const getFormData = () => {
      if (
        typeof data.callback.selector !== 'undefined' &&
        data.callback.selector !== null
      ) {
        return new FormData(document.querySelector(data.callback.selector));
      }
      formData.append('rubberduck_confirm', 'true');
      return formData;
    };
    var confirm = false;
    switch (data.callback.type) {
      case 'yesno':
        confirm = await ui.yesNo(data.callback.message, getTranslation('rubberduck', 'yes'), getTranslation('rubberduck', 'no'));
        if (confirm) {
          callMeAjax(data.callback.url, getFormData());
        }
        break;
      case 'okonly':
        await ui.okayOnly(data.callback.message);
        break;
      case 'okcancel':
        confirm = await ui.yesNo(data.callback.message, getTranslation('rubberduck', 'continue'), getTranslation('rubberduck', 'cancel'));
        if (confirm) {
          callMeAjax(data.callback.url, getFormData());
        }
        break;
      case 'yesnocancel':
      case 'abortretryignore':
      case 'retrycancel':
    }
  }
} //Gestion des erreurs ajax

const ui = {
  yesNo: async (message, yesMessage, noMessage) => createYesNo(message, yesMessage, noMessage),
  okayOnly: async (message) => createOkayOnly(message)
}

const createOkayOnly = (message) => {
  return new Promise(
    (complete, failed) => {
      let message_box = createMessageBox();
      let title_container = createTitle(message, ['center']);
      let okay_button = createButton('Ok', ['bg_blue']);
      okay_button.addEventListener('click', (e) => {
        message_box.message_box.remove();
        complete(true);
      });

      const btn_container = document.createElement('div');
      btn_container.classList.add('btn_section');
      btn_container.classList.add('center');
      btn_container.appendChild(okay_button);
      message_box.content.appendChild(title_container);
      message_box.content.appendChild(btn_container);
      document.body.appendChild(message_box.message_box);
    }
  );
}

const createYesNo = (message, yesMessage = 'Yes', noMessage = 'No') => {
  return new Promise(
    (complete, failed) => {
      let message_box = createMessageBox();
      let title_container = createTitle(message);
      let cancel_button = createButton(noMessage, ['border_blue', 'cancel']);
      cancel_button.addEventListener('click', (e) => {
        message_box.message_box.remove();
        complete(false);
      });
      let confirm_button = createButton(yesMessage, ['bg_blue', 'confirm', 'fright']);
      confirm_button.addEventListener('click', (e) => {
        message_box.message_box.remove();
        complete(true);
      });

      const btn_container = document.createElement('div');
      btn_container.classList.add('btn_section');
      btn_container.appendChild(cancel_button);
      btn_container.appendChild(confirm_button);
      message_box.content.appendChild(title_container);
      message_box.content.appendChild(btn_container);
      document.body.appendChild(message_box.message_box);
    }
  );
}

const createMessageBox = () => {
  const message_box = document.createElement('div');
  message_box.classList.add('custom_popup', 'no_handler', 'active', 'callback_popup');

  const curtain = document.createElement('div');
  curtain.classList.add('curtain');
  message_box.appendChild(curtain);

  const content = document.createElement('div');
  content.classList.add('popup_content');
  content.classList.add('margin_row');
  message_box.appendChild(content);
  return {
    message_box,
    content
  };
}

const createTitle = (message, extra_classes = []) => {
  const title_container = document.createElement('div');
  title_container.classList.add('row');
  const title = document.createElement('h4');
  title.classList.add('h3');
  extra_classes.forEach((single_class) => {
    title.classList.add(single_class);
  })
  title.innerText = message;
  title_container.appendChild(title);
  return title_container;
}

const createButton = (message, extra_classes = []) => {
  const button = document.createElement('span');
  button.classList.add('classy');
  extra_classes.forEach((single_class) => {
    button.classList.add(single_class);
  });

  const button_message = document.createElement('span');
  button_message.classList.add('txt');
  button_message.innerText = message;
  button.appendChild(button_message);

  return button;
}

function handleAjaxError(data) {
  // TODO Message générique lorsque erreur 400
  if (data.status && data.message) {
    displayNotification(data.status, data.message, data?.notification ?? {});
  }
} //Création de la notification et de son contenu

function generateNotification(status, message, {notification_type} = {
  notification_type: null,
}) {
  var content =
    '<div class="notification ' +
    (notification_type ?? status) +
    '"><span class="icon"></span><p>' +
    message +
    '</p></div>'; // <span class="close far fa-times"></span>
  $notification = $(content);
  $("#notifications").append($notification);
  return $notification;
} //Affichage d'une notification

export function displayNotification(status, message, params) {
  var _this = this;
  if ($("#notifications").length === 0) {
    $("body").append('<div id="notifications"></div>');
  } //Si déjà 5 notifications affichées on supprime la première avant d'afficher la suivante

  if ($("#notifications .notification").length >= 1) {
    hideNotification($("#notifications .notification").first(), 0);
  }

  var time = 5000;

  if (Array.isArray(message)) {
    Object.keys(message).forEach(
      function (key) {
        _newArrowCheck(this, _this);

        $notification = generateNotification(status, message[key], params);
        $notification.animate({
          top: "0",
          opacity: "1"
        },
          300
        );
        hideNotification($notification, time);
        time += 1000;
      }.bind(this)
    );
  } else {
    $notification = generateNotification(status, message, params);
    $notification.animate({
      top: "0",
      opacity: "1"
    },
      300
    );
    hideNotification($notification, time);
  }
} //Suppression d'une notification

function hideNotification($notification, $delay) {
  setTimeout(function () {
    $notification
    .animate({
      top: "-50px",
      opacity: 0,
      queue: false
    },
    100
    )
    setTimeout(function () {
      $notification.fadeOut(100, function () {
        $(this).remove();

        if ($("#notifications").children().length === 0) {
          $("#notifications").remove();
        }
      });
    }, 50);
  }, $delay);
} // Remove notification

$("body").on("click", ".notification .close", function (event) {
  var notification = $(event.target).parents(".notification");
  hideNotification(notification, 0);
});
